export class Credential {
  constructor(public email: string, public password: string) { }
}
